import React, {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from "react";
import { localStorageKeys } from "../constants";
import { setAuthorizationHeader } from "../utils/apiHelpers";

export type AuthType = {
  _id: string;
  avatar: string;
  firstName: string;
  lastName: string;
  role: "ADMIN" | "CUSTOMER_SUPPORT" | "OPERATOR";
  email: string;
} | null;

export const RootContext = createContext<{
  auth: AuthType;
  setAuth: React.Dispatch<React.SetStateAction<AuthType>>;
  clearAuth: () => void;
  accesstoken: string;
  setToken: Dispatch<SetStateAction<string>>;

  // updateAuth: (data: AuthType) => void;
  setHeaderTitle: (title?: React.ReactNode | string) => void;
  headerTitle?: React.ReactNode | string | null;
}>({
  auth: null,
  setAuth: () => {},
  clearAuth: () => {},
  accesstoken: "",
  setToken: () => {},
  // updateAuth: () => {},
  setHeaderTitle: () => {},
  headerTitle: null,
});

type RootProviderProps = {
  children: React.ReactNode;
};
export const RootProvider = ({ children }: RootProviderProps) => {
  const [isReady, setReady] = useState(false);
  const [auth, setAuth] = useState<AuthType | null>(null);
  const [accesstoken, setToken] = useState<string>("");
  const [title, setTitle] = useState<React.ReactNode | string | null>(null);

  const initAuth = async () => {
    const token = localStorage.getItem(localStorageKeys.accessToken);
    const userStrings = localStorage.getItem(localStorageKeys.user);
    const user = userStrings && JSON.parse(userStrings);

    if (token) {
      setAuthorizationHeader(token);
      setAuth(user);
      setToken(token);
    }

    setReady(true);
  };

  useEffect(() => {
    initAuth();
  }, []);

  const clearAuth = () => {
    // dispatch(removeAuth());
    localStorage.removeItem(localStorageKeys.user);
    localStorage.removeItem(localStorageKeys.accessToken);
  };

  return (
    <RootContext.Provider
      value={{
        auth,
        setAuth,
        clearAuth,
        // updateAuth,
        setToken,
        accesstoken,
        headerTitle: title,

        setHeaderTitle: setTitle,
      }}
    >
      {isReady ? children : null}
    </RootContext.Provider>
  );
};

export const useRoot = () => useContext(RootContext);

export default RootProvider;
